import {CSSProperties} from '../../../styleSheet';

export const getStaticDefaultPositionStyle = (): CSSProperties => {
  return {
    position: 'relative',
  };
};
